import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  TouchableOpacity,
  Modal,
  View,
  Keyboard,
  Dimensions,
} from "react-native";
import CustomText from "./CustomText";
import Icon from "react-native-vector-icons/Entypo";
import { ios, web } from "./Platform";
import { KeyboardAwareFlatList } from "react-native-keyboard-aware-scroll-view";
import { WrappedTextView } from "./CommonFunctions";
const screenWidth = Dimensions.get("screen").width;

const Dropdown = (props) => {
  let { label, options, onSelect, value, isValid } = props;

  value = (value || "").toString()?.split(",") || [];
  value = value.map((num) => Number(num));
  value = value.filter((num) => num != 0);

  const DropdownButton = useRef();
  const [visible, setVisible] = useState(false);
  const [dropdown, setDropdown] = useState({ top: 0, left: 0 });
  const [hoveredItem, setHoveredItem] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  useEffect(() => {
    setSelectedItems(value);
  }, [props]);

  const toggleItem = (item) => {
    let selectedItems_ = selectedItems;
    if (selectedItems_.includes(item)) {
      selectedItems_ = selectedItems_.filter(
        (selectedItem) => selectedItem != item
      );
    } else {
      selectedItems_ = [...selectedItems, item];
    }
    selectedItems_ = selectedItems_.filter((num) => Number(num) != 0);
    selectedItems_.forEach((item) => Number(item));

    setSelectedItems([...selectedItems_]);
    onSelect({ value: selectedItems_.join(",") });
  };

  const handleMouseEnter = (item) => {
    setHoveredItem(item);
  };
  const flatListRef = useRef(null);

  if (web) {
    useEffect(() => {
      if (flatListRef.current) {
        setTimeout(() => {
          flatListRef.current
            .getScrollResponder()
            ._innerViewRef.childNodes[0].childNodes[0].focus();
        }, 200);
      }
    }, [flatListRef.current]);
    useEffect(() => {
      DropdownButton?.current?.setNativeProps({
        tabIndex: -1,
      });
    }, [DropdownButton.current]);
  }

  const toggleDropdown = () => {
    visible ? setVisible(false) : openDropdown();
  };

  const openDropdown = async () => {
    if (!web) {
      await new Promise((resolve) => {
        Keyboard.dismiss();
        setTimeout(resolve, 100);
      });

      setTimeout(() => {
        DropdownButton.current.measure((_fx, _fy, _w, h, _px, py) => {
          setDropdown({ top: py + (h - 29), left: _px + 12, width: _w - 22 });
        });
        setVisible(true);
      }, 100);
    } else {
      DropdownButton.current.measure((_fx, _fy, _w, h, _px, py) => {
        setDropdown({ top: py + (h - 29), left: _px + 12, width: _w - 22 });
      });
      setVisible(true);
    }
  };

  const getFocusProps = () => {
    if (!web)
      return { tabIndex: 1, accessible: true, accessibilityRole: "button" };
    return {};
  };

  const renderItem = ({ item, index }) => {
    return (
      <TouchableOpacity
        activeOpacity={1}
        style={[
          styles.item,
          item == hoveredItem ? { backgroundColor: "#318CE7" } : {},
        ]}
        onPress={() => toggleItem(Number(item["value"]))}
        onMouseEnter={() => handleMouseEnter(item)}
        onMouseLeave={() => setHoveredItem(null)}
      >
        <CustomText
          style={[
            {
              paddingHorizontal: 15,
              paddingVertical: 7,
              fontSize: 15,
            },
            item == hoveredItem ? { color: "#fff" } : {},
          ]}
        >
          {item.label}
        </CustomText>
        {selectedItems.includes(Number(item["value"]?.toString().trim())) && (
          <Icon
            name="check"
            size={18}
            color={item == hoveredItem ? "#fff" : "black"}
            style={{ marginRight: 10, alignSelf: "center" }}
          />
        )}
      </TouchableOpacity>
    );
  };

  const renderDropdown = () => {
    return (
      <View style={{ flex: 1, flexDirection: "row" }}>
        <View
          style={[
            styles.inputBoxContainer,
            {
              borderColor: "gray",
              width: "100%",
              borderColor: isValid ? "red" : "silver",
            },
          ]}
        >
          <CustomText bold={true} style={styles.inputBoxLabel}>
            {label || ""}
          </CustomText>

          <TouchableOpacity
            onPress={toggleDropdown}
            {...getFocusProps()}
            style={[
              styles.inputBox,
              {
                width: "100%",
                marginRight: 10,
              },
            ]}
          >
            <Modal visible={visible} transparent animationType="fade">
              <TouchableOpacity
                activeOpacity={1}
                style={styles.overlay}
                onPress={() => setVisible(false)}
              >
                <View
                  style={[
                    styles.dropdown,
                    {
                      top: dropdown["top"],
                      left: dropdown["left"],
                      width: dropdown["width"],
                    },
                    dropdown["top"] == 0 &&
                      dropdown["left"] == 0 && { zIndex: -11111 },
                    web ? { overflow: "auto", maxHeight: 300 } : {},
                  ]}
                >
                  <KeyboardAwareFlatList
                    ref={flatListRef}
                    data={options}
                    renderItem={renderItem}
                  />
                </View>
              </TouchableOpacity>
            </Modal>
          </TouchableOpacity>
        </View>
      </View>
    );
  };
  const getLabelByValue = (value) => {
    const option = options.find((item) => item.value == value);
    return option ? option.label : "";
  };
  const getSelectedText = () => {
    let text = [];
    selectedItems.forEach((item, index) => text.push(getLabelByValue(item)));
    if (text.length == 0) return "Nothing selected";
    const selectedText = text.filter((_) => _).join(", ");
    return web
      ? selectedText
      : WrappedTextView({
          text: selectedText,
          maxLength: Math.floor((ios ? 41.5 : 47) * (screenWidth / 375)),
        });
  };

  return (
    <TouchableOpacity
      activeOpacity={1}
      tabIndex={-1}
      ref={DropdownButton}
      style={styles.button}
      onPress={toggleDropdown}
    >
      {renderDropdown()}
      <CustomText style={[styles.buttonText]}>
        <CustomText
          style={[
            {
              maxWidth: "100%",
              overflow: "hidden",
            },
            web && {
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "inline-block",
            },
          ]}
        >
          {getSelectedText()}
        </CustomText>
      </CustomText>
      <Icon style={styles.icon} name={`chevron-${visible ? "up" : "down"}`} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    flexDirection: "row",
    alignItems: "center",
    zIndex: 1,
  },
  buttonText: [
    {
      flex: 1,
      color: "rgb(81, 87, 93)",
      textAlign: "left",
      position: "absolute",
      top: 20,
      left: 15,
      maxWidth: "89%",
      overflow: "hidden",
    },
    web && {
      whiteSpace: "nowrap",
      display: "inline-block",
      textOverflow: "ellipsis",
    },
  ],
  icon: {
    right: 20,
    top: 22,
    position: "absolute",
  },
  dropdown: {
    position: "absolute",
    backgroundColor: "#fff",
    width: 350,
    // shadowColor: "#000000",
    // shadowRadius: 4,
    // shadowOffset: { height: 4, width: 0 },
    // shadowOpacity: 0.5,
    borderWidth: 1,
    borderColor: "#999",
    borderRadius: 3,
  },
  overlay: {
    width: "100%",
    height: "100%",
  },
  item: {
    borderBottomWidth: 1,
    borderBottomColor: "rgba(0,0,0,.04)",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  inputBoxContainer: {
    flexDirection: "row",
    borderColor: "gray",
    borderWidth: 1,
    borderRadius: 8,
    padding: 10,
    marginBottom: 20,
  },
  inputBoxLabel: {
    position: "absolute",
    backgroundColor: "#fff",
    top: -12,
    left: 3,
    fontSize: 14,
    color: "gray",
    paddingHorizontal: 3,
  },
  inputBox: {
    ...{
      borderWidth: 0,
      borderRadius: 5,
      fontSize: web ? 15 : 16,
      backgroundColor: "rgba(0,0,0,.04)",
      color: "#51575d",
      width: "100%",
      padding: 5,
      height: 35,
    },
  },
});

export default Dropdown;
